/* ═══════════════════════════════════════════════════════════════════════════
   Águas de Ipanema — posição do bundle/brinde na área de compra da PDP

   ÁGUAS DE IPANEMA — PDP BUNDLE ORDER RULE
   Promotional bundles and gifts must always render AFTER the main
   quantity + add-to-cart group and BEFORE the shipping calculator.

   O bloco NÃO é do tema: o app Rapi Bundle injeta `div.rapi-bundle-content-N`
   por JavaScript dentro do `<form class="shopify-product-form">`, que vive
   dentro de `.product-form__buy-buttons` — ou seja, entre a quantidade e o
   ADICIONAR AO CARRINHO. Medido em 10/09/2026 na PDP "Luz do Rio":
   quantidade no topo 105, brinde de 105 a 443, CTA em 452.

   Aqui o bloco é movido no DOM para depois de `.product-form__buy-buttons` e
   antes da calculadora de frete. É mudança estrutural, não `order` de CSS.

   Mover para fora do <form> é seguro: os campos do app (o radio do deal e os
   selects de variante) não têm atributo `name`, então nunca dependeram do
   submit nativo — o app lê tudo por JavaScript.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.__aipBundlePdp) return;
  window.__aipBundlePdp = true;

  function reposicionar(bloco) {
    var form = bloco.closest('.product-form');
    if (!form) return;

    var botoes = form.querySelector(':scope > .product-form__buy-buttons');
    if (!botoes) return;

    /* Já está no lugar? Não mexe — senão o observador entra em laço. */
    if (bloco.parentElement === form && bloco.previousElementSibling === botoes) return;

    botoes.insertAdjacentElement('afterend', bloco);
    bloco.classList.add('aip-bundle-reposicionado');
  }

  /* ÁGUAS DE IPANEMA — PDP QUANTITY RULE
     Every purchasable PDP with an active Add to Cart button must render the
     global quantity selector immediately beside the main Add to Cart button
     unless an explicitly documented fixed-quantity rule applies.

     Causa auditada em 11/09/2026 (Beija Flor Carioca e todo produto com
     brinde): o Liquid renderiza o seletor normalmente, mas o rappi-front.js
     do Rapi Bundle escreve style="display:none" inline no <quantity-selector>
     quando o brinde está ativo. Aqui o inline é desfeito toda vez que o app
     o escreve (o observador abaixo já acompanha o DOM). Só o seletor da área
     de compra principal; o quick-buy não entra. */
  function restaurarQuantidade() {
    document.querySelectorAll('.product__info .product-form__quantity, .product__info .product-form__quantity quantity-selector').forEach(function (el) {
      if (el.style && el.style.display === 'none') {
        el.style.removeProperty('display');
      }
      if (el.hidden) el.hidden = false;
    });
  }

  function varrer() {
    document.querySelectorAll('[class*="rapi-bundle-content"]').forEach(reposicionar);
    restaurarQuantidade();
  }

  /* O bloco é injetado depois do carregamento e o app o reconstrói inteiro a
     cada troca de variante principal — por isso o observador fica de pé.
     setTimeout e não requestAnimationFrame: rAF pode não disparar em aba de
     segundo plano e o bloco ficaria no lugar errado. */
  var pendente = null;
  new MutationObserver(function () {
    if (pendente) return;
    pendente = setTimeout(function () { pendente = null; varrer(); }, 0);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden'] });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', varrer);
  } else { varrer(); }
})();
